import { FETCH_ALL_UPDATES } from "../../src/components/ImpactManagement/1-projects/constants/constants";

export function storeUpdateList(data) {
  const action = {
    type: 'FETCH_ALL_UPDATES',
    data
  }
  return action;
}